<template>
  <basic-container>
    <div class="avue-crud">
      <el-form :inline="true">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input
            v-model="queryParams.menuName"
            placeholder="请输入菜单名称"
            clearable
            size="small"
            @keyup.enter.native="getList"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

          <el-button v-if="!permissions.sys_menu_add" icon="el-icon-plus" type="primary"
                     @click="addOrUpdateHandle(false)">
            添加
          </el-button>
        </el-form-item>
      </el-form>
      <div style="height: calc(100vh + -105px);">
      <el-table
        border
        v-loading="loading"
        :data="menuList"
        row-key="id"
        height="100%"
        :tree-props="{children: 'children', hasChildren: 'hasChildrens'}">
        <el-table-column prop="name" label="菜单名称" :show-overflow-tooltip="true" width="180"></el-table-column>
        <el-table-column prop="icon" label="图标" align="center" width="100">
          <template slot-scope="scope">
            <i :class="scope.row.icon"/>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="60"></el-table-column>
        <el-table-column prop="path" label="组件路径" :show-overflow-tooltip="true" width="200"></el-table-column>
        <el-table-column prop="menuType" label="类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.menuType === '0'">左菜单</el-tag>
            <el-tag type="success" v-if="scope.row.menuType === '2'">顶菜单</el-tag>
            <el-tag type="info" v-if="scope.row.menuType === '1'">按钮</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="keepAlive" label="缓冲" width="80" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.keepAlive === '0'">关闭</el-tag>
            <el-tag type="success" v-if="scope.row.keepAlive === '1'">开启</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="permission" label="权限标识" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" width="300" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              icon="el-icon-plus"
              @click="addOrUpdateHandle(false,scope.row.id)"
              v-if="permissions.sys_menu_add">新增
            </el-button>
            <el-button size="small"
                       type="text"
                       icon="el-icon-edit"
                       @click="addOrUpdateHandle(true,scope.row.id)"
                       v-if="permissions.sys_menu_edit">修改
            </el-button>
            <el-button
              size="small"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-if="permissions.sys_menu_del">删除
            </el-button>
            <el-button
              size="small"
              type="text"
              icon="el-icon-view"
              @click="lookOverS(scope.row.id)"
              v-if="permissions.sys_menu_del">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
</div>
      <table-form v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getList"></table-form>

      <lookOverDialog :visiable.sync="lookOver" @commit="closeLook" v-if="lookOver"  :menuID="menuID" ></lookOverDialog>

    </div>
  </basic-container>
</template>

<script>
import {delObj, fetchMenuTree} from '@/api/admin/menu'
import TableForm from './menu-form'
import lookOverDialog from './lookOverDialog.vue'

import {mapGetters} from 'vuex'

export default {
  name: "menu",
  components: {TableForm,lookOverDialog},
  data() {
    return {
      menuID:'',
      lookOver: false,
      addOrUpdateVisible: false,
      // 遮罩层
      loading: true,
      // 菜单表格树数据
      menuList: [],
      // 菜单树选项
      menuOptions: [],
      // 查询参数
      queryParams: {
        parentId: undefined,
        menuName: ""
      },
    };
  },
  created() {
    this.getList();

  },
  computed: {
    ...mapGetters(['permissions']),

  },
  methods: {
    closeLook(){
      this.lookOver=false

    },
    lookOverS(e){
    console.log(e,'查看点击的ID');
      this.lookOver=true
      this.menuID=e
    },
    addOrUpdateHandle(isEdit, id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(isEdit, id)
      })
    },
    getList() {
      this.loading = true;

      fetchMenuTree(this.queryParams).then(response => {
        this.menuList = response.data.data
        this.loading = false;
      });
      console.log(this.permissions,"permissions的值");
    },
    handleDelete(row) {
      this.$confirm('是否确认删除名称为"' + row.name + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delObj(row.id);
      }).then(() => {
        this.getList();
        this.$message.success('删除成功')
      })
    }
  }
};
</script>
